<template>
  <qx-card title="列表">
    <SetSalaryDialog ref="setSalaryDialog" />
    <LogRightDialog ref="logRightDialog" busiCode="100002" />
    <QuitDialog ref="quitDialog" @sub="getData" />
    <InAgainDialog ref="inAgainDialog" @sub="getData" />
    <PhoneDialog ref="phoneDialog" @sub="getData" />
    <UploadDriverCardDialog ref="uploadDriverCardDialog" @sub="getData" />
    <UploadIdCardDialog ref="uploadIdCardDialog" @sub="getData" />
    <section slot="titleRight">
      <qx-permpisions permpisions="1002020101">
        <el-button type="primary" plain @click="() => showSetSalaryDialog()">
          <i class="iconfont">&#xe6ac;</i>批量设置工资
        </el-button>
      </qx-permpisions>
      <qx-permpisions permpisions="1002020102">
        <el-dropdown>
          <el-button type="primary" plain>
            <i class="iconfont">&#xe6ac;</i>证照批量上传
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <qx-permpisions>
              <el-dropdown-item @click.native="showUploadIdCardDialog"
                >身份证上传</el-dropdown-item
              >
            </qx-permpisions>
            <qx-permpisions>
              <el-dropdown-item @click.native="showDriverCardDialog"
                >驾驶证上传</el-dropdown-item
              >
            </qx-permpisions>
          </el-dropdown-menu>
        </el-dropdown>
      </qx-permpisions>
      <qx-permpisions permpisions="1400109">
        <ImportBtn
          title="导入"
          groupCode="impDriverInfo"
          :bizCodes="['imp1000124', 'imp1000123']"
          :fileUrl="[
            '/file/外调车司机导入模板.xlsx',
            '/file/自有车司机导入模板.xlsx',
          ]"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="1400110">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="userInfoBO.ajax?cmd=doQueryDrivers"
          :params="fullSearchData"
          bizName="司机数据导出"
          bizCode="exp100092"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="1400101">
        <el-button type="primary" plain @click="() => toEdit()">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>
      <qx-permpisions permpisions="1400111">
        <el-button type="primary" plain @click="() => toFastAdd()">
          <i class="iconfont">&#xe6ab;</i>快速新增
        </el-button>
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <el-table-column type="selection" width="55" />
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <!-- 司机账号 -->
                <section
                  v-if="scope.column.property === 'loginAcct'"
                  @click="toDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <!-- 司机账号 end -->
                <!-- 归属车队 -->
                <section
                  v-else-if="scope.column.property === 'attachTenantName'"
                >
                  <span
                    v-if="
                      scope.row.attachTenantId !== -1 &&
                      scope.row.attachTenantName
                    "
                    class="primary cur"
                    @click="toTenantDetail(scope.row)"
                    >{{ scope.row[scope.column.property] }}</span
                  >
                  <span v-else>{{ scope.row[scope.column.property] }}</span>
                </section>
                <!-- 归属车队 end -->
                <!-- 证件预警 -->
                <section v-else-if="scope.column.property === 'expiredString'">
                  <el-popover
                    v-if="scope.row.expiredString2"
                    trigger="hover"
                    :content="scope.row.expiredString2"
                  >
                    <div slot="reference" class="primary cur">
                      {{ scope.row[scope.column.property] }}
                    </div>
                  </el-popover>
                  <span v-else>{{ scope.row[scope.column.property] }}</span>
                </section>
                <!-- 证件预警 end -->
                <!-- 车辆数量 -->
                <section
                  v-else-if="scope.column.property === 'vehicleNum'"
                  @click="toCarList(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <!-- 车辆数量 end -->
                <!-- 银行卡 -->
                <section v-else-if="scope.column.property === 'bindStateName'">
                  <template v-if="checkPermpisions()">
                    <span class="primary cur" @click="toBankcard(scope.row)">
                      {{ scope.row[scope.column.property] }}
                    </span>
                  </template>
                  <template v-else>
                    <span>
                      {{ scope.row[scope.column.property] }}
                    </span>
                  </template>
                </section>
                <!-- 银行卡 end -->
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            fixed="right"
            width="170"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    showCondition: scope.row.hasVer === 0,
                    name: '审核',
                    event: () => toDetail(scope.row, 'approve'),
                  },
                  {
                    permpisions: '1400102',
                    showCondition: scope.row.entryState !== 2,
                    name: '修改',
                    event: () => toEdit(scope.row.userId),
                  },
                  {
                    permpisions: '1400104',
                    showCondition: true,
                    name: '修改手机号',
                    event: () => showPhoneDialog(scope.row),
                  },
                  {
                    permpisions: '1400103',
                    showCondition: true,
                    name: '删除',
                    event: () => del(scope.row),
                  },
                  {
                    showCondition:
                      scope.row.carUserType === 1 && scope.row.entryState === 1,
                    name: '离职',
                    event: () => showQuitDialog(scope.row),
                  },
                  {
                    showCondition: scope.row.entryState === 2,
                    name: '再入职',
                    event: () => showInAgainDialog(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.relId),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.currentPage"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import QuitDialog from './quitDialog';
import InAgainDialog from './inAgainDialog';
import PhoneDialog from './phoneDialog';
import UploadIdCardDialog from './uploadIDCardDialog';
import UploadDriverCardDialog from './uploadDriverCardDialog';
import ImportBtn from 'components/importBtn';
import ExportBtn from 'components/exportBtn';
import SetSalaryDialog from './setSalaryDialog';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  driverArchivesList,
  driverArchivesDel,
} from 'api/archives';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    QuitDialog,
    InAgainDialog,
    PhoneDialog,
    UploadDriverCardDialog,
    UploadIdCardDialog,
    ImportBtn,
    ExportBtn,
    SetSalaryDialog,
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        selectTar: 'userId',
        title: [ // 表头
          { prop: 'loginAcct', label: '司机账号', fixed: true },
          { prop: 'linkman', label: '司机名称' },
          { prop: 'carUserTypeName', label: '司机类型' },
          { prop: 'attachTenantName', label: '归属车队' },
          { prop: 'attachTennantLinkman', label: '车队联系人' },
          { prop: 'attachTennantLinkPhone', label: '车队电话' },
          { prop: 'expiredString', label: '证件预警' },
          { prop: 'vehicleNum', label: '车辆数量' },
          { prop: 'stateName', label: '待审核状态' },
          { prop: 'entryStateName', label: '在职状态' },
          { prop: 'acctName1', label: '银行卡1账户名', show: false },
          { prop: 'acctNo1', label: '银行卡1卡号', show: false },
          { prop: 'bankName1', label: '银行卡1开户行', show: false },
          { prop: 'remark1', label: '银行卡1备注', show: false },
          { prop: 'acctName2', label: '银行卡2账户名', show: false },
          { prop: 'acctNo2', label: '银行卡2卡号', show: false },
          { prop: 'bankName2', label: '银行卡2开户行', show: false },
          { prop: 'remark2', label: '银行卡2备注', show: false },
          { prop: 'icbcEcardRegisAccount', label: '工行E卡注册账号', show: false },
          // 暂时屏蔽支付相关的操作
          // { prop: 'bindStateName', label: '银行卡' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: driverArchivesList,
    toBankcard (item) {
      if (item.state === 1) {
        this.$message.warning('请先认证会员！');
        return;
      }
      this.jump({
        label: '银行卡信息',
        url: `/manage/other/bankcard?userId=${item.userId}&linkman=${encodeURIComponent(item.linkman)}&idNum=${item.identification}`,
        full: true,
      });
    },
    toTenantDetail (item) {
      this.jump({
        label: '车队详情',
        url: `/manage/other/fleet/base?id=${item.attachTenantId}`,
        full: true,
      });
    },
    async del (item) {
      const confirmRes = await this.$confirm('是否确认删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
      if (confirmRes === 'confirm') {
        const res = await driverArchivesDel({
          userId: item.userId,
          relId: item.relId,
        });
        if (!res.failed) {
          this.$message.success('删除成功');
          this.getData();
        }
      }
    },
    toCarList (item) {
      this.jump({
        label: '自有车档案',
        url: '/manage/car/archives/my?mobilePhone=' + item.loginAcct,
      });
    },
    toDetail (item, type = '') {
      this.jump({
        label: type ? '审核司机' : '司机详情',
        url: `/manage/archives/driver/archives/detail?id=${item.userId}&type=${type}`,
        full: true,
      });
    },
    toFastAdd () {
      this.jump({
        label: '快速新增司机',
        url: '/manage/archives/driver/archives/fastAdd',
      });
    },
    toEdit (id) {
      this.jump({
        label: id ? '修改司机' : '新增司机',
        url: `/manage/archives/driver/archives/edit${id ? '?id=' + id : ''}`,
        full: true,
      });
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
    handleImport (file) { // 导入
      this.$refs.importDialog.show(false);
    },
    showPhoneDialog (item) { // 打开修改手机号弹窗
      this.$refs.phoneDialog.show(item);
    },
    showQuitDialog (item) { // 打开离职弹窗
      this.$refs.quitDialog.show(item);
    },
    showInAgainDialog (item) { // 打开再入职弹窗
      this.$refs.inAgainDialog.show(item);
    },
    showUploadIdCardDialog () { // 打开上传身份证弹窗
      this.$refs.uploadIdCardDialog.show();
    },
    showDriverCardDialog () { // 打开上传驾驶证弹窗
      this.$refs.uploadDriverCardDialog.show();
    },
    showSetSalaryDialog () { // 批量设置工资
      if (this.tableData.selectResult.length === 0) {
        this.$message.warning('请先选择司机');
        return;
      }
      this.$refs.setSalaryDialog.show(this.tableData.selectResult);
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
